"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMarkAsReadNotification = useMarkAsReadNotification;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _headers = require("../constants/headers");
var _logger = require("../logger");
var _isOnBehalf = require("../utils/isOnBehalf");
var _withHandePost = require("../utils/withHandePost");
const isDevelopment = process.env.NODE_ENV === 'development';
const logger = _logger.mainLogger.createChild('useMarkAsViewedQuery');
function useMarkAsReadNotification() {
  const {
    token,
    customerId
  } = (0, _auth.useToken)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const mutation = async notification => {
    const onBehalf = (0, _isOnBehalf.isOnBehalf)(token);
    if (!isDevelopment && onBehalf || !notification.notificationId) {
      return true;
    }
    return (0, _withHandePost.withHandlePost)((0, _globalApiClientReact.createCustomerInAppNotificationViewed)(globalApiClient, customerId, notification.notificationId, {
      [_headers.HEADER_KEY_X_CLIENT_APPLICATION]: _headers.HEADER_VALUE_X_CLIENT_APPLICATION
    }), {
      onError: error => logger.error(new Error('Failed to mark notification as viwed', {
        cause: error
      }))
    });
  };
  return [mutation];
}